import { helper } from '@ember/component/helper';
import { warnIfNotDateOnly } from '../utils/date/warn-if-not-date-only';

type Input = string | number | boolean | Record<string, unknown> | null | undefined;

interface Signature {
  Args: { Positional: [Input] };
  Return: string;
}

/**
 * Renders a date-only `YYYY-MM-DD` string as `MM/DD/YYYY`.
 *
 * Date-only input ONLY. A full ISO instant has its time and offset discarded,
 * which can render the wrong day; such input is reported via `warnIfNotDateOnly`
 * rather than repaired, because the correct rendering depends on whether the
 * value is a calendar date or a real event. Format instants at the call site.
 *
 * Anything that does not start with the `YYYY-MM-DD` shape renders as `''` —
 * including single-digit months/days, which never match the `{2}` groups.
 */
export default helper<Signature>(function formatDateString([raw]: [Input]) {
  if (typeof raw !== 'string' || !raw) return '';

  warnIfNotDateOnly(raw, 'formatDateString');

  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';

  const [, yyyy, mm, dd] = m;
  return `${mm}/${dd}/${yyyy}`;
});
